import React from 'react';
import { Formik } from 'formik';
import { Alert, Form, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import CustomModal from '../../../../../components/custom_modal/CustomModal';
import { schema } from './schema';
import CustomTabs from '../../../../../components/tabs/CustomTabs';
import { tabsOptions } from './tabsOptions';
import MultipleOption from './images/1.jpeg';
import SingleOption from './images/2.jpeg';
import TextManyLines from './images/3.jpeg';
import TextOneLine from './images/4.jpeg';
import NumericValue from './images/5.jpeg';
import DateValue from './images/6.jpeg';
import DateTimeValue from './images/7.jpeg';
import MatrizValue from './images/8.jpeg';
import { questionsList } from './questionsTypeOptions';
import { createSurveyQuestionTemplate, 
         updateSurveyQuestionTemplate} from '../../../../../redux/survey/surver_template/questions/actions';
import AlertFormServerErrors from '../../../../../components/alert_form_server_errors/AlertFormServerErrors';

const QuestionForm = ({ show, setShow, isEdit, question }) => {
  const [sortableState, setSortableState] = React.useState(null);
  const [error, setError] = React.useState('');
  const { surveyTemplate } = useSelector(state => state.surveyTemplate);
  const { surveyTemplateQuestions: questions } = useSelector(state => state.surveyTemplateQuestions);
  const handleClose = () => setShow(false);
  const { isFormSaving, formError } = useSelector(state => state.surveyTemplateQuestions);
  const dispatch = useDispatch();
  const onSubmit = (values) => {
    setError('');
    debugger;
    if (surveyTemplate.survey_type === "Evaluación" && !isEdit) {
      const scoreQuestionsTotal = questions.reduce((acc, question) => parseFloat(acc) + parseFloat(question.score), 0) + parseFloat(values.score);
      if (scoreQuestionsTotal >= parseFloat(surveyTemplate.total_score)) {
        //toastr.error("El puntaje total de las preguntas no puede ser mayor o igual al puntaje total de la encuesta");
        setError("El puntaje total de las preguntas no puede ser mayor o igual al puntaje total de la encuesta");
        return;
      }
    }
    const trigger = values.triggerAnswer ? JSON.parse(values.triggerAnswer) : null;
    const payload = {
      ...values,
      triggeredQuestion: trigger ? trigger[0] : null,
      triggerAnswer: trigger ? trigger[1] : null,
      secuence: isEdit ? question.secuence : questions.length + 1,
      survey_id: surveyTemplate.id,
    };
    const actionPayload = { question: payload, options: sortableState?.options || [], combinations: sortableState?.combinations || [] };
    if (isEdit) {
      dispatch(updateSurveyQuestionTemplate(question.id, actionPayload, setShow));
    } else {
      dispatch(createSurveyQuestionTemplate(actionPayload, setShow));
    }
  }
  // const onSubmit = (values) => {
  //   if (surveyTemplate.survey_type === "Evaluación") {
  //       const score_questions_total = questions.reduce((acc, question) => {
  //         return acc + question.score;
  //       }, 0) + values.score;
  //       if(score_questions_total >= surveyTemplate.total_score){
  //         toastr.error("El puntaje total de las preguntas no puede ser mayor o igual al puntaje total de la encuesta");
  //         return;
  //       }
  //   }
  //   const trigger = values.triggerAnswer ? JSON.parse(values.triggerAnswer) : null;
  //   const payload = {
  //     ...values,
  //     triggeredQuestion: trigger ? trigger[0] : null,
  //     triggerAnswer: trigger ? trigger[1] : null,
  //   };

  //   payload.secuence = isEdit ? question.secuence : questions.length + 1;
  //   if (isEdit) {
  //     dispatch(updateSurveyQuestionTemplate(question.id, {question: {...payload, survey_id: surveyTemplate.id}, options: sortableState}, setShow));
  //   } else {
  //     dispatch(createSurveyQuestionTemplate({question:{...payload, survey_id: surveyTemplate.id}, options: sortableState}, setShow));
  //   }
  // }
  const renderImage = (questionType) => {
    switch (questionType) {
      case 'Opción múltiple: solo una respuesta':
        return <img src={SingleOption} alt="Single Option" />;
      case 'Opción múltiple: se permiten varias respuestas':
        return <img src={MultipleOption} alt="Multiple Option" />;
      case 'Cuadro de texto con varias líneas':
        return <img src={TextManyLines} alt="Text Many Lines" />;
      case 'Cuadro de texto de una línea':
        return <img src={TextOneLine} alt="Text One Line" />;
      case 'Valor numérico':
        return <img src={NumericValue} alt="Numeric Value" />;
      case 'Fecha':
        return <img src={DateValue} alt="Date Value" />;
      case 'Fecha y hora':
        return <img src={DateTimeValue} alt="DateTime Value" />;
      case 'Matriz':
        return <img src={MatrizValue} alt="Matrix Value" />;
      default:
        return null;
    }
  };

  return (
    <Formik initialValues={{
        name: isEdit ? question?.name : '',
        description: isEdit ? question.description : '',
        finalMessage: isEdit ? question.finalMessage : '',
        showFieldComment: isEdit ? question.showFieldComment : false,
        messageComment: isEdit ? question.messageComment : '',
        isCommentAnswer: isEdit ? question.isCommentAnswer : false,
        triggerAnswer: isEdit ? (question.triggerAnswer && question.triggeredQuestion ? JSON.stringify([question.triggeredQuestion, question.triggerAnswer]) : '') : '',
        isRequiredAnswer: isEdit ? question.isRequiredAnswer : false,
        errorMessage: isEdit ? question.errorMessage : '',
        helperText: isEdit ? question.helperText : '',
        requiredValidInput: isEdit ? question.requiredValidInput : false,
        min: isEdit && question.min ? question.min : '',
        max: isEdit && question.max ? question.max : '',
        validationError: isEdit ? question.validationError : '',
        questionType: isEdit ? question.questionType : 'Opción múltiple: solo una respuesta',
        score: isEdit ? question.score : 0,
      }} validationSchema={schema} 
         onSubmit={onSubmit}
         enableReinitialize>
       {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <CustomModal 
          show={show} 
          handleClose={handleClose} 
          handleSave={handleSubmit} 
          title={isEdit ? 'Editar pregunta' : 'Nueva pregunta'}
          isForm={true}
          isSaving={isFormSaving}
          dialogClassName="modal-90w">
          {
            formError && formError.fields_with_errors && (
              <AlertFormServerErrors formError={formError} />
            )
          }
          {
            error && (
              <Alert variant="danger" className="my-3">
                {error}
              </Alert>
            )
          }
          <Form.Group>
            <Form.Label className="ml-2">Pregunta</Form.Label>
            <Form.Control 
              className="rounded-pill"
              type="text" 
              name="name" 
              placeholder="Pregunta"
              isInvalid={touched.name && errors.name}
              value={values.name} 
              onChange={handleChange} 
              onBlur={handleBlur} />
            <Form.Control.Feedback className="ml-2" type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Row>
              <Col md={8}>
                <Form.Row>
                  <Col md={3}>
                    <Form.Label className="font-weight-bold">Tipo de pregunta</Form.Label>
                  </Col>
                  <Col md={9}>
                    {  
                      questionsList.map((item, index) => (
                        <Form.Check
                          className="mb-1"
                          key={index}
                          type="radio"
                          name="questionType"
                          onChange={e => setFieldValue('questionType', item)}
                          checked={item === values.questionType}
                          label={item} />
                      ))
                    }
                  </Col>
                </Form.Row>
              </Col>
              <Col md={4}>
                {renderImage(values.questionType)}
              </Col>
            </Row>
          </Form.Group>
          <CustomTabs 
              defaultActiveKey="description"
              id="surveyTemplateOptions"
              tabs={tabsOptions(values, handleChange, setFieldValue, errors, questions, question, setSortableState)} />
        </CustomModal>
      )}
    </Formik>
  )
}

export default QuestionForm;